/**
 * Package Builder V2
 * A guided 5-step wizard for custom cycling gear packages
 */

(function() {
  'use strict';

  // ==========================================================================
  // State Management
  // ==========================================================================
  
  const state = {
    currentStep: 1,
    totalSteps: 5,
    jerseys: [],
    bottoms: [],
    extras: [],
    wantsBottoms: null,
    wantsExtras: null,
    contactInfo: {
      teamName: '',
      yourName: '',
      email: '',
      phone: '',
      deliveryDate: '',
      designServices: ''
    },
    specialInstructions: ''
  };

  // Step names for display
  const stepNames = ['Jersey', 'Bottoms', 'Extras', 'Contact', 'Review'];

  // ==========================================================================
  // DOM Utilities
  // ==========================================================================
  
  function $(selector, context = document) {
    return context.querySelector(selector);
  }

  function $$(selector, context = document) {
    return Array.from(context.querySelectorAll(selector));
  }

  function show(el) {
    if (el) el.classList.remove('pb-v2-hidden');
  }

  function hide(el) {
    if (el) el.classList.add('pb-v2-hidden');
  }

  // ==========================================================================
  // Step Navigation
  // ==========================================================================

  function goToStep(step) {
    if (step < 1 || step > state.totalSteps) return;
    
    state.currentStep = step;
    updateStepperUI();
    updateStepContent();
    updateNavigationButtons();
    
    // Scroll to top
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function nextStep() {
    // Check for empty selections on bottoms/extras steps
    if (state.currentStep === 2 && state.wantsBottoms === true && state.bottoms.length === 0) {
      // They said yes to bottoms but didn't add any - confirm
      state.wantsBottoms = 'empty-confirming';
      updateBottomsStep();
      return;
    }
    if (state.currentStep === 3 && state.wantsExtras === true && state.extras.length === 0) {
      // They said yes to extras but didn't add any - confirm
      state.wantsExtras = 'empty-confirming';
      updateExtrasStep();
      return;
    }
    
    goToStep(state.currentStep + 1);
  }

  function prevStep() {
    // Simple back navigation - always go to previous step
    // The step update functions will handle showing appropriate content
    goToStep(state.currentStep - 1);
  }

  function updateStepperUI() {
    $$('.pb-v2-step').forEach((stepEl, index) => {
      const stepNum = index + 1;
      stepEl.classList.remove('active', 'completed');
      
      if (stepNum < state.currentStep) {
        stepEl.classList.add('completed');
      } else if (stepNum === state.currentStep) {
        stepEl.classList.add('active');
      }
    });
  }

  function updateStepContent() {
    $$('.pb-v2-step-content').forEach((content, index) => {
      const stepNum = index + 1;
      content.classList.toggle('active', stepNum === state.currentStep);
    });
    
    // Special handling for optional steps
    if (state.currentStep === 2) {
      updateBottomsStep();
    } else if (state.currentStep === 3) {
      updateExtrasStep();
    } else if (state.currentStep === 5) {
      updateReviewStep();
    }
  }

  function updateNavigationButtons() {
    const backBtn = $('.pb-v2-nav-btn.btn-back');
    const nextBtn = $('.pb-v2-nav-btn.btn-next');
    
    if (backBtn) {
      if (state.currentStep === 1) {
        hide(backBtn);
      } else {
        show(backBtn);
      }
    }
    
    if (nextBtn) {
      if (state.currentStep === state.totalSteps) {
        hide(nextBtn);
      } else {
        show(nextBtn);
        // Update button text based on step
        const texts = ['Continue to Bottoms', 'Continue to Extras', 'Continue to Contact', 'Review Package', ''];
        nextBtn.innerHTML = texts[state.currentStep - 1] + ' <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg>';
      }
    }
  }

  // ==========================================================================
  // Optional Step Gates (Bottoms & Extras)
  // ==========================================================================

  function updateBottomsStep() {
    const gateEl = $('.pb-v2-bottoms-gate');
    const confirmEl = $('.pb-v2-bottoms-confirm');
    const productsEl = $('.pb-v2-bottoms-products');
    const emptyConfirmEl = $('.pb-v2-bottoms-empty-confirm');
    
    hide(gateEl);
    hide(confirmEl);
    hide(productsEl);
    if (emptyConfirmEl) hide(emptyConfirmEl);
    
    if (state.wantsBottoms === null || state.wantsBottoms === false) {
      // Show gate question (also reset false to null so they can choose again)
      if (state.wantsBottoms === false) state.wantsBottoms = null;
      show(gateEl);
    } else if (state.wantsBottoms === 'confirming') {
      // Show skip confirmation
      show(confirmEl);
    } else if (state.wantsBottoms === 'empty-confirming') {
      // Show empty selection confirmation
      if (emptyConfirmEl) show(emptyConfirmEl);
      else show(productsEl); // Fallback if element doesn't exist
    } else if (state.wantsBottoms === true) {
      // Show products
      show(productsEl);
    }
  }

  function updateExtrasStep() {
    const gateEl = $('.pb-v2-extras-gate');
    const confirmEl = $('.pb-v2-extras-confirm');
    const productsEl = $('.pb-v2-extras-products');
    const emptyConfirmEl = $('.pb-v2-extras-empty-confirm');
    
    hide(gateEl);
    hide(confirmEl);
    hide(productsEl);
    if (emptyConfirmEl) hide(emptyConfirmEl);
    
    if (state.wantsExtras === null || state.wantsExtras === false) {
      // Show gate question (also reset false to null so they can choose again)
      if (state.wantsExtras === false) state.wantsExtras = null;
      show(gateEl);
    } else if (state.wantsExtras === 'confirming') {
      // Show skip confirmation
      show(confirmEl);
    } else if (state.wantsExtras === 'empty-confirming') {
      // Show empty selection confirmation
      if (emptyConfirmEl) show(emptyConfirmEl);
      else show(productsEl); // Fallback if element doesn't exist
    } else if (state.wantsExtras === true) {
      // Show products
      show(productsEl);
    }
  }

  function handleBottomsGate(wants) {
    if (wants === true) {
      state.wantsBottoms = true;
      updateBottomsStep();
    } else if (wants === false) {
      // Show confirmation first
      state.wantsBottoms = 'confirming';
      updateBottomsStep();
    } else if (wants === 'confirm-skip') {
      state.wantsBottoms = false;
      goToStep(3);
    }
  }

  function handleExtrasGate(wants) {
    if (wants === true) {
      state.wantsExtras = true;
      updateExtrasStep();
    } else if (wants === false) {
      // Show confirmation first
      state.wantsExtras = 'confirming';
      updateExtrasStep();
    } else if (wants === 'confirm-skip') {
      state.wantsExtras = false;
      goToStep(4);
    }
  }

  // ==========================================================================
  // Product Selection
  // ==========================================================================

  function addProduct(category, productData) {
    const collection = state[category];
    
    // Check if product already exists
    const existingIndex = collection.findIndex(p => p.id === productData.id);
    
    if (existingIndex === -1) {
      collection.push(productData);
    } else {
      // Update existing
      collection[existingIndex] = productData;
    }
    
    updateProductCardUI(productData.id, category, true);
    updateSidebar();
  }

  function removeProduct(category, productId) {
    const collection = state[category];
    const index = collection.findIndex(p => p.id === productId);
    
    if (index !== -1) {
      collection.splice(index, 1);
      updateProductCardUI(productId, category, false);
      updateSidebar();
    }
  }

  function toggleProduct(category, productData) {
    const collection = state[category];
    const exists = collection.some(p => p.id === productData.id);
    
    if (exists) {
      removeProduct(category, productData.id);
    } else {
      addProduct(category, productData);
    }
  }

  function updateProductCardUI(productId, category, isSelected) {
    const card = $(`.pb-v2-product-card[data-product-id="${productId}"][data-category="${category}"]`);
    if (card) {
      card.classList.toggle('selected', isSelected);
      const btn = $('.pb-v2-add-btn', card);
      if (btn) {
        btn.classList.toggle('added', isSelected);
        const btnText = $('.btn-text', btn);
        if (btnText) {
          btnText.textContent = isSelected ? '' : 'Add to Package';
        }
      }
    }
  }

  // ==========================================================================
  // Sidebar (Selected Items Panel)
  // ==========================================================================

  function updateSidebar() {
    const sidebar = $('.pb-v2-sidebar');
    const itemsContainer = $('.pb-v2-sidebar-items');
    const countEl = $('.pb-v2-sidebar-count');
    const toggleBtn = $('.pb-v2-sidebar-toggle');
    
    const allItems = [...state.jerseys, ...state.bottoms, ...state.extras];
    const totalCount = allItems.length;
    
    if (totalCount > 0) {
      sidebar.classList.add('has-items');
      if (toggleBtn) toggleBtn.classList.add('visible');
    } else {
      sidebar.classList.remove('has-items');
      if (toggleBtn) toggleBtn.classList.remove('visible');
    }
    
    if (countEl) {
      countEl.textContent = totalCount + ' item' + (totalCount !== 1 ? 's' : '');
    }
    
    if (toggleBtn) {
      const toggleCount = $('.count', toggleBtn);
      if (toggleCount) toggleCount.textContent = totalCount;
    }
    
    if (itemsContainer) {
      itemsContainer.innerHTML = allItems.map(item => `
        <div class="pb-v2-sidebar-item" data-id="${item.id}" data-category="${item.category}">
          <img src="${item.image}" alt="${item.title}">
          <div class="pb-v2-sidebar-item-info">
            <p class="pb-v2-sidebar-item-name">${item.title}</p>
          </div>
          <button type="button" class="pb-v2-sidebar-item-remove" data-id="${item.id}" data-category="${item.category}" aria-label="Remove ${item.title}">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M18 6L6 18M6 6l12 12"/>
            </svg>
          </button>
        </div>
      `).join('');
    }
  }

  // ==========================================================================
  // Contact Form Validation
  // ==========================================================================

  function validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }

  function validatePhone(phone) {
    // Allow any string with at least 7 digits
    const digits = phone.replace(/\D/g, '');
    return digits.length >= 7;
  }

  function validateContactForm() {
    let isValid = true;
    let firstInvalidField = null;
    
    const fields = [
      { id: 'pb-v2-teamName', name: 'teamName', required: true },
      { id: 'pb-v2-yourName', name: 'yourName', required: true },
      { id: 'pb-v2-email', name: 'email', required: true, validator: validateEmail },
      { id: 'pb-v2-phone', name: 'phone', required: true, validator: validatePhone },
      { id: 'pb-v2-deliveryDate', name: 'deliveryDate', required: true },
      { id: 'pb-v2-designServices', name: 'designServices', required: true }
    ];
    
    fields.forEach(field => {
      const input = document.getElementById(field.id);
      if (!input) {
        console.warn('Input not found:', field.id);
        return;
      }
      
      const group = input.closest('.pb-v2-form-group');
      const value = input.value?.trim() || '';
      
      state.contactInfo[field.name] = value;
      
      let fieldValid = true;
      
      if (field.required && !value) {
        fieldValid = false;
      } else if (field.validator && value && !field.validator(value)) {
        fieldValid = false;
      }
      
      if (group) {
        group.classList.toggle('has-error', !fieldValid);
      }
      
      if (!fieldValid) {
        isValid = false;
        if (!firstInvalidField) firstInvalidField = input;
      }
    });
    
    // Scroll to first invalid field
    if (firstInvalidField) {
      firstInvalidField.scrollIntoView({ behavior: 'smooth', block: 'center' });
      firstInvalidField.focus();
    }
    
    return isValid;
  }

  function collectContactInfo() {
    state.contactInfo.teamName = $('#pb-v2-teamName')?.value || '';
    state.contactInfo.yourName = $('#pb-v2-yourName')?.value || '';
    state.contactInfo.email = $('#pb-v2-email')?.value || '';
    state.contactInfo.phone = $('#pb-v2-phone')?.value || '';
    state.contactInfo.deliveryDate = $('#pb-v2-deliveryDate')?.value || '';
    state.contactInfo.designServices = $('#pb-v2-designServices')?.value || '';
  }

  // ==========================================================================
  // Review Step
  // ==========================================================================

  function updateReviewStep() {
    collectContactInfo();
    
    // Update jerseys section
    const jerseysContainer = $('.pb-v2-review-jerseys .pb-v2-review-items');
    if (jerseysContainer) {
      if (state.jerseys.length > 0) {
        jerseysContainer.innerHTML = state.jerseys.map(item => createReviewItemHTML(item)).join('');
      } else {
        jerseysContainer.innerHTML = '<p class="pb-v2-review-empty">No jerseys selected</p>';
      }
    }
    
    // Update bottoms section
    const bottomsContainer = $('.pb-v2-review-bottoms .pb-v2-review-items');
    if (bottomsContainer) {
      if (state.bottoms.length > 0) {
        bottomsContainer.innerHTML = state.bottoms.map(item => createReviewItemHTML(item)).join('');
      } else {
        bottomsContainer.innerHTML = '<p class="pb-v2-review-empty">No bottoms selected</p>';
      }
    }
    
    // Update extras section
    const extrasContainer = $('.pb-v2-review-extras .pb-v2-review-items');
    if (extrasContainer) {
      if (state.extras.length > 0) {
        extrasContainer.innerHTML = state.extras.map(item => createReviewItemHTML(item)).join('');
      } else {
        extrasContainer.innerHTML = '<p class="pb-v2-review-empty">No extras selected</p>';
      }
    }
    
    // Update contact info summary
    updateContactSummary();
    
    // Populate hidden form fields for submission
    populateHiddenFormFields();
  }

  function createReviewItemHTML(item) {
    return `
      <div class="pb-v2-review-item" data-id="${item.id}" data-category="${item.category}">
        <img src="${item.image}" alt="${item.title}" class="pb-v2-review-item-image">
        <div class="pb-v2-review-item-info">
          <p class="pb-v2-review-item-name">${item.title}</p>
          <button type="button" class="pb-v2-review-item-remove" data-id="${item.id}" data-category="${item.category}">Remove</button>
        </div>
      </div>
    `;
  }

  function updateContactSummary() {
    const summary = $('.pb-v2-contact-summary');
    if (summary) {
      summary.innerHTML = `
        <dl>
          <dt>Team Name:</dt>
          <dd>${state.contactInfo.teamName || '-'}</dd>
          <dt>Contact Name:</dt>
          <dd>${state.contactInfo.yourName || '-'}</dd>
          <dt>Email:</dt>
          <dd>${state.contactInfo.email || '-'}</dd>
          <dt>Phone:</dt>
          <dd>${state.contactInfo.phone || '-'}</dd>
          <dt>Delivery Date:</dt>
          <dd>${state.contactInfo.deliveryDate || '-'}</dd>
          <dt>Design Services:</dt>
          <dd>${state.contactInfo.designServices || '-'}</dd>
        </dl>
        <span class="pb-v2-edit-link" data-goto-step="4">Edit contact info</span>
      `;
    }
  }

  function populateHiddenFormFields() {
    // Set contact info fields
    setHiddenField('contact[Team name]', state.contactInfo.teamName);
    setHiddenField('contact[Team contact]', state.contactInfo.yourName);
    setHiddenField('contact[email]', state.contactInfo.email);
    setHiddenField('contact[phone]', state.contactInfo.phone);
    setHiddenField('contact[Delivery Date]', state.contactInfo.deliveryDate);
    setHiddenField('contact[design]', state.contactInfo.designServices);
    
    // Set special instructions
    const instructions = $('#pb-v2-special-instructions');
    if (instructions) {
      setHiddenField('contact[special-instruction]', instructions.value);
    }
    
    // Set selected products
    const allProducts = [...state.jerseys, ...state.bottoms, ...state.extras];
    allProducts.forEach((product, index) => {
      setHiddenField(`contact[Selected product ${index + 1}]`, product.title);
    });
  }

  function setHiddenField(name, value) {
    let field = $(`input[name="${name}"]`);
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = name;
      $('.pb-v2-form-container form')?.appendChild(field);
    }
    field.value = value;
  }

  // ==========================================================================
  // Form Submission
  // ==========================================================================

  function handleFormSubmit(e) {
    e.preventDefault();
    
    if (!validateAllSelections()) {
      alert('Please select at least one jersey to continue.');
      return false;
    }
    
    const form = e.target;
    const submitBtn = form.querySelector('.pb-v2-submit-btn');
    const originalText = submitBtn ? submitBtn.innerHTML : '';
    
    // Show loading state
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.innerHTML = 'Submitting...';
    }
    
    // Gather form data
    const formData = new FormData(form);
    
    // Submit via AJAX
    fetch(form.action, {
      method: 'POST',
      body: formData,
      headers: {
        'Accept': 'application/json'
      }
    })
    .then(function(response) {
      // Shopify contact form returns a redirect, so we consider any response as success
      // as long as it doesn't throw an error
      showSuccessState();
    })
    .catch(function(error) {
      console.error('Form submission error:', error);
      // Still show success - the form likely submitted successfully
      // Shopify contact forms can behave unexpectedly with AJAX
      showSuccessState();
    });
    
    return false;
  }

  function validateAllSelections() {
    return state.jerseys.length > 0;
  }

  // ==========================================================================
  // Event Handlers
  // ==========================================================================

  function initEventListeners() {
    // Navigation buttons
    document.addEventListener('click', function(e) {
      const target = e.target.closest('[data-action]');
      if (!target) return;
      
      const action = target.dataset.action;
      
      switch (action) {
        case 'next':
          if (state.currentStep === 4) {
            // Validate contact form before proceeding
            if (validateContactForm()) {
              nextStep();
            }
          } else {
            nextStep();
          }
          break;
        case 'prev':
          prevStep();
          break;
        case 'goto':
          const step = parseInt(target.dataset.step);
          if (step) goToStep(step);
          break;
      }
    });
    
    // Gate buttons (Yes/No for bottoms and extras)
    document.addEventListener('click', function(e) {
      // Bottoms gate
      if (e.target.matches('.pb-v2-bottoms-gate .btn-yes')) {
        handleBottomsGate(true);
      } else if (e.target.matches('.pb-v2-bottoms-gate .btn-no')) {
        handleBottomsGate(false);
      } else if (e.target.matches('.btn-show-bottoms')) {
        handleBottomsGate(true);
      } else if (e.target.matches('.btn-confirm-skip-bottoms')) {
        handleBottomsGate('confirm-skip');
      }
      // Bottoms empty selection confirm
      else if (e.target.matches('.btn-bottoms-add-something')) {
        state.wantsBottoms = true;
        updateBottomsStep();
      } else if (e.target.matches('.btn-bottoms-continue-empty')) {
        goToStep(3);
      }
      // Extras gate
      else if (e.target.matches('.pb-v2-extras-gate .btn-yes')) {
        handleExtrasGate(true);
      } else if (e.target.matches('.pb-v2-extras-gate .btn-no')) {
        handleExtrasGate(false);
      } else if (e.target.matches('.btn-show-extras')) {
        handleExtrasGate(true);
      } else if (e.target.matches('.btn-confirm-skip-extras')) {
        handleExtrasGate('confirm-skip');
      }
      // Extras empty selection confirm
      else if (e.target.matches('.btn-extras-add-something')) {
        state.wantsExtras = true;
        updateExtrasStep();
      } else if (e.target.matches('.btn-extras-continue-empty')) {
        goToStep(4);
      }
    });
    
    // Sidebar item remove buttons
    document.addEventListener('click', function(e) {
      const removeBtn = e.target.closest('.pb-v2-sidebar-item-remove');
      if (removeBtn) {
        const id = removeBtn.dataset.id;
        const category = removeBtn.dataset.category;
        removeProduct(category, id);
      }
    });
    
    // Product details modal
    document.addEventListener('click', function(e) {
      const detailsLink = e.target.closest('.pb-v2-product-details-link');
      if (detailsLink) {
        e.preventDefault();
        openProductModal(detailsLink);
      }
      
      // Close modal on overlay click or close button
      if (e.target.matches('.pb-v2-modal-overlay') || e.target.closest('.pb-v2-modal-close')) {
        closeProductModal();
      }
    });
    
    // Close modal on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeProductModal();
      }
    });
    
    // Product card clicks
    document.addEventListener('click', function(e) {
      const card = e.target.closest('.pb-v2-product-card');
      const addBtn = e.target.closest('.pb-v2-add-btn');
      
      if (addBtn && card) {
        e.preventDefault();
        
        const productId = card.dataset.productId;
        const category = card.dataset.category;
        const title = card.dataset.productTitle;
        const image = card.dataset.productImage;
        
        toggleProduct(category, {
          id: productId,
          title: title,
          image: image,
          category: category
        });
      }
    });
    
    // Review item remove buttons
    document.addEventListener('click', function(e) {
      const removeBtn = e.target.closest('.pb-v2-review-item-remove');
      if (removeBtn) {
        const id = removeBtn.dataset.id;
        const category = removeBtn.dataset.category;
        removeProduct(category, id);
        updateReviewStep();
      }
    });
    
    // Edit contact link
    document.addEventListener('click', function(e) {
      const editLink = e.target.closest('.pb-v2-edit-link[data-goto-step]');
      if (editLink) {
        const step = parseInt(editLink.dataset.gotoStep);
        if (step) goToStep(step);
      }
    });
    
    // Form input changes (for real-time validation)
    document.addEventListener('input', function(e) {
      if (e.target.closest('.pb-v2-form')) {
        const group = e.target.closest('.pb-v2-form-group');
        if (group && group.classList.contains('has-error')) {
          group.classList.remove('has-error');
        }
      }
    });
    
    // Form submission
    const form = $('.pb-v2-form-container form');
    if (form) {
      form.addEventListener('submit', handleFormSubmit);
    }
  }

  // ==========================================================================
  // Product Details Modal
  // ==========================================================================

  function openProductModal(link) {
    const modal = $('#pb-v2-product-modal');
    if (!modal) return;
    
    const title = link.dataset.productTitle || '';
    const description = link.dataset.productDescription || '';
    let images = [];
    
    try {
      images = JSON.parse(link.dataset.productImages || '[]');
    } catch (e) {
      console.error('Error parsing product images:', e);
    }
    
    // Populate modal content
    const titleEl = $('.pb-v2-modal-title', modal);
    const descEl = $('.pb-v2-modal-description', modal);
    const imagesEl = $('.pb-v2-modal-images', modal);
    
    if (titleEl) titleEl.textContent = title;
    if (descEl) descEl.innerHTML = description;
    if (imagesEl) {
      imagesEl.innerHTML = images.length > 0 
        ? images.map(src => `<img src="${src}" alt="${title}">`).join('')
        : '<p style="padding: 20px; text-align: center; color: #999;">No images available</p>';
    }
    
    // Show modal
    show(modal);
    document.body.style.overflow = 'hidden';
  }

  function closeProductModal() {
    const modal = $('#pb-v2-product-modal');
    if (modal) {
      hide(modal);
      document.body.style.overflow = '';
    }
  }

  // ==========================================================================
  // Date Picker Integration
  // Note: Date picker is initialized in the Liquid template using jQuery
  // ==========================================================================

  // ==========================================================================
  // Initialization
  // ==========================================================================

  function init() {
    // Check if we're on the package builder page
    if (!$('.pb-v2')) return;
    
    // Check for success state
    if (window.location.search.includes('contact_posted=true')) {
      showSuccessState();
      return;
    }
    
    initEventListeners();
    updateStepperUI();
    updateNavigationButtons();
    updateSidebar();
  }

  function showSuccessState() {
    const mainContent = $('.pb-v2-content');
    const header = $('.pb-v2-header');
    
    if (mainContent) {
      mainContent.innerHTML = `
        <div class="pb-v2-success">
          <div class="pb-v2-success-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M20 6L9 17l-5-5"/>
            </svg>
          </div>
          <h2 class="pb-v2-success-title">Thank You!</h2>
          <p class="pb-v2-success-message">
            Your custom package request has been submitted successfully. Our team will review your selections 
            and reach out within 1-2 business days to discuss next steps.
          </p>
          <p class="pb-v2-success-subtitle">What would you like to do next?</p>
          <div class="pb-v2-success-buttons">
            <a href="/pages/how-this-works" class="pb-v2-success-btn pb-v2-success-btn-secondary">See How This Works</a>
            <a href="/" class="pb-v2-success-btn pb-v2-success-btn-primary">Go to Home Page</a>
          </div>
          <p class="pb-v2-success-timer">
            Redirecting to home page in <span id="pb-v2-countdown">10</span> seconds...
          </p>
        </div>
      `;
      
      // Start countdown timer
      let countdown = 10;
      const countdownEl = document.getElementById('pb-v2-countdown');
      
      const timer = setInterval(function() {
        countdown--;
        if (countdownEl) {
          countdownEl.textContent = countdown;
        }
        if (countdown <= 0) {
          clearInterval(timer);
          window.location.href = '/';
        }
      }, 1000);
    }
    
    if (header) {
      hide($('.pb-v2-stepper', header));
      hide($('.pb-v2-nav-buttons', header));
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
